import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import PaymentForm from './Form/PaymentForm';
import Order from '../APIController/Order';
import { useEffect, useState } from 'react';
import WorkspaceSelector from '../Helper/WorkspaceSelector';

const StripePayment = ({ amount, deviceId }) => {
    const { getFullCurrentWorkspace } = WorkspaceSelector()
    const stripePromise = loadStripe(getFullCurrentWorkspace().workspaceDTO.stripePublic);
    const [clientSecret, setClientSecret] = useState(null);
    const { createPayment } = Order();

    useEffect(() => {
        getSecret()
    }, [])


    const getSecret = async () => {
        const response = await createPayment({ amount: amount, currency: 'chf' });
        setClientSecret(response.clientSecret)
    }

    if (!clientSecret) return <p>Loading payment...</p>;

    const options = {
        clientSecret,
        appearance: { theme: "stripe" },
    };

    return (
        <Elements stripe={stripePromise} options={options}>
            <PaymentForm deviceId={deviceId} />
        </Elements>

    );
}

export default StripePayment;